/* eslint-disable eqeqeq */
import { getHeadersOld } from "./helper";
// import { getHeaders } from "./helper";

export let HttpRequest = async (
  method = "GET",
  url = "",
  data = {},
  headerVariant = ""
) => {
  let response = {};
  let config = {
    method: method,
    headers: getHeadersOld(headerVariant),
  };
  if (data != null) {
    config.body = data;
  }
  await fetch(url, config)
    .then((res) => {
      if (!res.ok) {
        throw res;
      }
      return res.json();
    })
    .then((result) => {
      console.log(result);
      if (result.success === 1) {
        response = {
          statusCode: result.success,
          isSuccess: true,
          message: "something",
          userMessage: "",
          data: result || [],
        };
      } else {
        if (result.CODE === 1) {
          response = {
            statusCode: result.CODE,
            isSuccess: true,
            message: result.USER_MESSAGE + "\n" + result.SYSTEM_MESSAGE,
            userMessage: "",
            data: result.DATA || [],
          };
        } else if (result.CODE === 4) {
          response = {
            statusCode: result.CODE || result.success,
            isSuccess: false,
            message: result.USER_MESSAGE + "\n" + result.SYSTEM_MESSAGE,
            userMessage: "",
            data: null,
          };
        } else {
          response = {
            statusCode: result.CODE || result.success,
            isSuccess: false,
            message: result.USER_MESSAGE + "\n" + result.SYSTEM_MESSAGE,
            userMessage: "",
            data: null,
          };
        }
      }
    })
    .catch((error) => {
      if (error.status == 401) {
        response = {
          statusCode: error.status,
          isSuccess: false,
          message: "Invalid/Expired token, Please login again to continue",
          data: [],
        };
      } else {
        response = {
          statusCode: error.status,
          isSuccess: false,
          message: "An error occurred on server please contact IT support team",
          userMessage: "",
          data: [],
        };
      }
    });
  return response;
};

export let HttpRequestHome = async (
  method = "POST",
  url = "",
  body = "",
  jwttoken
) => {
  let response = {};
  await fetch(url, {
    method: method,
    body: body,
    headers: new Headers({
      Authorization: "Bearer " + jwttoken,
    }),
  })
    .then((res) => {
      if (!res.ok) {
        throw res;
      }
      return res.json();
    })
    .then((result) => {
      console.log(result);
      if (result.success === 1) {
        response = {
          statusCode: result.success,
          isSuccess: true,
          message: "something",
          data: result || [],
        };
      } else {
        if (result.CODE === 1) {
          response = {
            statusCode: result.CODE,
            isSuccess: true,
            message: result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE,
            data: result.DATA || [],
          };
        } else if (result.CODE === 4) {
          response = {
            statusCode: result.CODE || result.success,
            isSuccess: false,
            message: result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE,
            data: null,
          };
        } else {
          response = {
            statusCode: result.CODE || result.success,
            isSuccess: false,
            message: result.SYSTEM_MESSAGE + "\n" + result.USER_MESSAGE,
            data: null,
          };
        }
      }
    })
    .catch((error) => {
      if (error.status == 401) {
        response = {
          statusCode: error.status,
          isSuccess: false,
          message: "Invalid/Expired token, Please login again to continue",
          data: [],
        };
      } else {
        response = {
          statusCode: error.status,
          isSuccess: false,
          message: "An error occured: " + error.status,
          data: [],
        };
      }
    });
  return response;
};

export let HttpRequestFileDownload = async (
  method = "GET",
  url = "",
  headerVariant = ""
) => {
  let response = {};
  await fetch(url, {
    method: method,
    headers: getHeadersOld(headerVariant),
  })
    .then((res) => {
      if (!res.ok) {
        throw res;
      }
      return res.blob();
    })
    .then((result) => {
      response = {
        statusCode: 200,
        isSuccess: true,
        message: "file Received",
        data: result || [],
      };
    })
    .catch((error) => {
      if (error.status == 401) {
        response = {
          statusCode: error.status,
          isSuccess: false,
          message: "Invalid/Expired token, Please login again to continue",
          data: [],
        };
      } else {
        response = {
          statusCode: error.status,
          isSuccess: false,
          message: "An error occurred on server please contact IT support team",
          data: [],
        };
      }
    });
  return response;
};
